export const userFields = [
  {
    value: "first_name",
    label: "First Name",
    group: "user_field"
  },
  {
    value: "last_name",
    label: "Last Name",
    group: "user_field"
  },
  {
    value: "email",
    label: "E-mail (required)",
    componentLabel: "E-mail",
    group: "user_field"
  },
  {
    value: "dob",
    label: "Date of Birth",
    group: "user_field"
  },
  {
    value: "gender",
    label: "Gender",
    field_type: "gender",
    group: "user_field"
  },
  {
    value: "title",
    label: "Title",
    field_type: "gender",
    group: "user_field"
  },
  {
    value: "address1",
    label: "Address 1",
    group: "user_field"
  },
  {
    value: "address2",
    label: "Address 2",
    group: "user_field"
  },
  {
    value: "city",
    label: "City",
    group: "user_field"
  },
  {
    value: "state",
    label: "State",
    group: "user_field"
  },
  {
    value: "zip",
    label: "Zip Code",
    group: "user_field"
  },
  {
    value: "phone",
    label: "Phone",
    group: "user_field"
  }
]

export const consentFields = [
  {
    value: "registration_consent",
    label: "Registration Consent",
    field_type: "registration_consent",
    group: "consent",
    hiddenBy: ['bundled_consent'],
  },
  {
    value: "tcpa_consent",
    label: "TCPA Consent",
    field_type: "tcpa_consent",
    group: "consent",
    hiddenBy: ['bundled_consent'],
  },
  {
    value: "recording_consent",
    label: "Recording Consent",
    field_type: "recording_consent",
    group: "consent"
  },
  {
    value: "bundled_consent",
    label: "TCPA & Registration Consent",
    field_type: "bundled_consent",
    group: "consent",
    hiddenBy: ['registration_consent', 'tcpa_consent'],
  },
]

export const dynamicContentFields = [
  {
    value: "twyne_registration",
    label: "Twyne Registration",
    group: "dynamic_content"
  },
  {
    value: "password",
    label: "Password",
    group: "user_field"
  },
  {
    value: "password_confirmation",
    label: "Password Confirmation ",
    group: "user_field"
  }
]

export const staticFields = [
  {
    value: "label",
    label: "Label",
    group: "static_fields"
  },
  {
    value: "jumper",
    label: "Jump from registration",
    group: "static_fields"
  },
  {
    value: "html",
    label: "HTML",
    group: "static_fields"
  },
  {
    value: "submit",
    label: "Custom Submit Button",
    componentLabel: "CONTINUE",
    group: "Other"
  },
  {
    value: "previous_step_button",
    label: "Previous Step Button",
    componentLabel: "BACK",
    group: "Other"
  },
  {
    value: "timer_submit",
    label: "Timer submit",
    group: "Other",
  },
  {
    value: "heading",
    label: "Heading",
    group: "static_fields",
  },
]

export const twyneRegistrationTriggerTypes = [
  {
    value: "percent",
    label: "Percent",
  },
  {
    value: "fields",
    label: "Fields",
  }
]

export const twyneRegistrationTriggerFields = [
  { value: 'first', label: 'First Name' },
  { value: 'last', label: 'Last Name' },
  { value: 'email', label: 'E-mail' },
  { value: 'address1', label: 'Address 1' },
  { value: 'address2', label: 'Address 2' },
  { value: 'city', label: 'City' },
  { value: 'gender', label: 'Gender' },
  { value: 'state', label: 'State' },
  { value: 'zip', label: 'Zip' },
  { value: 'phone', label: 'Phone' },
  { value: 'dob', label: 'Dob' }
]

export const extraRuleFields = [
  {
    value: 'phone',
    type: 'input',
    label: 'Phone',
    group: 'User Fields'
  }, {
    value: 'first_name',
    type: 'input',
    label: 'First Name',
    group: 'User Fields'
  }, {
    value: 'last_name',
    type: 'input',
    label: 'Last Name',
    group: 'User Fields'
  }
]

class RulesVisible {
  constructor(data) {
    this.data = data
  }
  get field() {
    return this.data.field || ''
  }

  get required() {
    return this.data.field_required || false
  }

  get isCustomField() {
    return this.data.custom_field || false
  }

  get fieldComponent() {
    return this.data.field_component || ''
  }

  get fieldType() {
    return this.data.field_type || ''
  }

  defaultCheck(validation) {
    return (init = true) => {

      if (Array.isArray(init) && !init.length)
        return undefined

      if (typeof init === 'object' && Object.values(init).every(val => val === undefined))
        return undefined

      if (validation())
        return init

      return undefined
    }
  }

  *getValidations() {
    if (this.field === 'password')
      yield { label: 'Is less than six digits', value: 'isSixOrMore' }

    if (this.field === 'password_confirmation')
      yield { label: 'Is not matching', value: 'isPasswordConfirmationMatching' }
    else
      if (this.required)
        yield { label: 'Is required', value: 'isRequired' }

    if (this.field === 'email') {
      yield { label: 'Is not an e-mail', value: 'isValidEmail' }
      yield { label: 'Failed Verification', value: 'isFailedVerificationEmail' }
    }

    if (this.field === 'zip') {
      yield { label: 'Is less than five digits', value: 'isFiveDigitsZip' }
      yield { label: 'Is not a number', value: 'isNumber' }
      yield { label: 'Failed Verification', value: 'isFailedVerificationPostal' }
    }

    if (this.field === 'phone') {
      yield { label: 'Is less than ten digits', value: 'isTenDigitsPhone' }
      yield { label: 'Has no area code', value: 'isValidPhoneAreaCode' }
      yield { label: 'Failed Verification', value: 'isFailedVerificationPhone' }
    }

    if (this.field === 'dob') {
      yield { label: 'Is 18 years old', value: 'is18YearsOld' }
    }
  }

  isPopulateVisible = this.defaultCheck(() => {
    if (['label', 'html', 'tcpa_consent', 'recording_consent', 'heading'].includes(this.field) || this.fieldComponent === "datepicker" || this.fieldComponent === "date_triple_select")
      return false

    return true
  })

  isDatasourceVisible = this.defaultCheck(() => {
    if (!this.isCustomField || (this.fieldType !== 'input'))
      return false

    return true
  })

  isPlaceholderVisible = this.defaultCheck(() => {
    if (this.field === 'gender')
      return false

    if (this.field === 'title')
      return false

    if (this.field === 'state')
      return false

    if (this.field === 'dob')
      return false

    if (this.data.custom_field && ['text', 'password', 'textarea'].includes(this.fieldComponent))
      return true

    if (this.data.custom_field)
      return false

    if (this.field === 'recording_consent')
      return false

    return true
  })

  isPrepopulateWithVisible = this.defaultCheck(() => {
    if (this.field === 'email')
      return false

    if (this.field.startsWith('password'))
      return false

    return true
  })

  isIPIntelligenceVisible = this.defaultCheck(() => {
    if (this.field === 'state')
      return true

    if (this.field === 'city')
      return true

    if (this.field === 'zip')
      return true

    return false
  })

  isPopulateOptionsVisible = this.defaultCheck(() => {
    if (this.field.startsWith('password'))
      return false

    if (userFields.some(d => d.value === this.field)) {
      if (['state'].includes(this.field))
        return true
      return false
    }

    if (this.data.custom_field) {
      if (this.fieldType === 'input')
        return false
      if (this.fieldType === 'boolean')
        return false
    }

    return true
  })

  isVisibilityVisible = this.defaultCheck(() => {
    if (this.field === 'tcpa_consent' || this.field === 'recording_consent')
      return false

    return true
  })

  isValidationsVisible = this.defaultCheck(() => {
    if (['label', 'html', 'heading'].includes(this.field))
      return false

    return true
  })

  isAutohideVisible = this.defaultCheck(() => {
    if (['label', 'html', 'heading'].includes(this.field))
      return false

    return true
  })

  isHideControlVisible = this.defaultCheck(() => {
    return true
  })

  isShowControlVisible = this.defaultCheck(() => {
    return true
  })

  isRequiredVisible = this.defaultCheck(() => {
    if (this.field === 'recording_consent') {
      if (this.fieldComponent === 'checkbox')
        return true
      return false
    }
    // if (this.fieldType === 'gender' && this.fieldComponent === 'radio')
    // return false
    return true
  })

  isValidationsTypesVisible = this.defaultCheck(() => {

    return true
  })

  isRulesActive = this.defaultCheck(() => {
    if (!this.field)
      return false

    if (this.data.custom_field)
      return true

    if (this.field.startsWith('password'))
      return true

    if (['label', 'html', 'recording_consent', 'heading'].includes(this.field))
      return true

    if (this.field === 'tcpa_consent' && ['checkbox', 'checkbox_instructions_text'].includes(this.fieldComponent))
      return true

    return !!userFields.find(item => item.value === this.field)
  })
}

export function visibleRules(fieldData) {
  const rules = new RulesVisible(fieldData)

  return rules.isRulesActive({
    datasource: rules.isDatasourceVisible(true),
    populate: rules.isPopulateVisible({
      placeholder: rules.isPlaceholderVisible(),
      prepopulateWith: rules.isPrepopulateWithVisible(),
      populateOptions: rules.isPopulateOptionsVisible(),
      ipIntelligence: rules.isIPIntelligenceVisible(),
    }),

    visibility: rules.isVisibilityVisible({
      autohide: rules.isAutohideVisible(),
      hideControl: rules.isHideControlVisible(),
      showControl: rules.isShowControlVisible(),
    }),

    validations: rules.isValidationsVisible({
      required: rules.isRequiredVisible(),
      validations: rules.isValidationsTypesVisible([...rules.getValidations()])
    })
  })
}

export const mergetagsTemplates = [
  ['address1', 'address1'],
  ['address2', 'address2'],
  ['city', 'city'],
  ['email', 'email'],
  ['test', 'test'],
  ['first_name', 'first_name'],
  ['last_name', 'last_name'],
  ['phone', 'phone'],
  ['zip', 'zip'],
  ['state', 'state'],
  ['gender', 'gender'],
  ['dob_month', 'dob_month'],
  ['dob_day', 'dob_day'],
  ['dob_year', 'dob_year'],
]
